export { AtnDsPillButtonComponent as Component } from './pill-button.component'
